<template>
  <div class="bar-b">
    <div class="bar-item" @click="sendLetter">
      <img src="~images/platform/homepage/bottom-bar-talk-icon.png" alt="" />
      <p>私信</p>
    </div>
    <div class="bar-item" @click="toggleFollow">
      <template v-if="hasFollow">
        <img src="~images/platform/homepage/bottom-bar-agree.png" alt="" />
        <p>已关注</p>
      </template>
      <template v-else>
        <img src="~images/platform/homepage/bottom-bar-disagree.png" alt="" />
        <p>关注</p>
      </template>
    </div>
    <div class="btn-large-wrap">
      <div
        class="btn-large"
        :style="{ background: btnMsg.bgColor }"
        @click="onBtnClick"
      >
        <div class="tips" v-if="btnMsg.tip">{{ btnMsg.tip }}</div>
        <img
          v-if="btnMsg.showIcon"
          src="~images/platform/homepage/qingsu-chat.png"
          alt=""
        />
        <span>{{ btnMsg.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from 'component/platform/homepage/eventBus.js'
import { mapGetters } from 'vuex'
import { getQingsuReminder, setQingsuReminder } from 'api/platform/homepage.js'
import Bridge from 'lib/lib/Bridge'
const COLOR = {
  DARK_RED: 'linear-gradient(180deg, #feb6a9 0%, #fc7052 100%', // 深红色，可正常下单
  LIGHT_RED: '#FFBCB0', // 浅红色，服务中
  GRAY: 'rgb(204, 204, 204)' // 灰色，禁止下单
}

export default {
  props: {
    qingsuType: {
      type: String,
      default: 'voice'
    }
  },
  data() {
    return {
      remnderIds: []
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'loginUser']),
    qingsuService() {
      return this.$store.state.homepage.qingsuService
    },
    firstOrder() {
      const discountInfo = this.qingsuService.discount_info
      if (!discountInfo) {
        return false
      }
      return discountInfo.firstOrder
    },
    teacherInfo() {
      return this.qingsuService.info || {}
    },
    consultation_text() {
      return this.qingsuService.consultation_text || {}
    },
    userRelation() {
      return this.$store.state.homepage.userRelation
    },
    // 是否已关注
    hasFollow() {
      return this.userRelation && +this.userRelation.follow === 1
    },
    orderTip() {
      if (this.qingsuType === 'voice' && this.firstOrder) {
        return `首单${Number(this.teacherInfo.voice_price)}`
      }
      if (this.qingsuType === 'text') {
        if (
          +this.teacherInfo.jin === 0 &&
          +this.teacherInfo.text_status &&
          +this.consultation_text.consultation_price === 0
        ) {
          return '首单免费'
        }
      }
      return ''
    },
    mixinIsApp() {
      const { isYixinliApp, isZiXunApp, isZiXunShiApp } = this.$platform
      return isYixinliApp || isZiXunApp || isZiXunShiApp
    },
    roleInfo() {
      return this.qingsuService.role_info || {}
    },
    discountInfo() {
      return this.qingsuService.discount_info || {}
    },
    serviceMsg() {
      // 是否提供文字倾诉服务 0否 1是
      const is_provide_text = Number(this.teacherInfo.is_provide_text)
      // 是否提供语音倾诉服务 0否 1是
      const is_provide_voice = Number(this.teacherInfo.is_provide_voice)
      const result = [
        {
          name: '语音倾诉',
          type: 'voice',
          shown: is_provide_voice
        },
        {
          name: '文字倾诉',
          type: 'text',
          shown: is_provide_text
        }
      ]
      return result.filter(v => v.shown)
    },
    btnMsg() {
      // 0元下单 > 0元体验 > 0元公益
      // 0元下单和0元公益只能二选一
      let result = {}
      const service = this.serviceMsg.find(
        item => item.type === this.qingsuType
      )
      const teacherId = this.$route.params.userId
      const self = this
      if (service) {
        // 文字倾诉
        if (service.type === 'text') {
          // 文字倾诉价格
          const consultation_price = +this.consultation_text.consultation_price
          const text_status = +this.teacherInfo.text_status
          // 是否被禁
          const jin = +this.teacherInfo.jin
          let value =
            jin === 1
              ? '暂停服务'
              : ['已休息', '向ta提问', '服务中'][text_status]

          let clickHandler = () => {
            if (this.banned) return
            if (text_status === 0) {
              // 倾听师上线提醒
              if (this.mixinIsApp && this.roleInfo.role !== 'qingting') {
                if (this.isLogin && this.remnderIds.includes(+teacherId)) {
                  this.$toast({
                    text: '您已设置过该位倾听师的上线提醒，请耐心等候'
                  })
                } else {
                  this.goToRemind()
                }
              }
            }
            if (text_status === 1) {
              self.toOrder()
            }
          }
          let bgColor =
            jin === 1
              ? COLOR.GRAY
              : [COLOR.GRAY, COLOR.DARK_RED, COLOR.LIGHT_RED][text_status]
          // 倾听师上线提醒
          if (
            this.mixinIsApp &&
            this.roleInfo.role !== 'qingting' &&
            text_status === 0
          ) {
            if (this.isLogin && this.remnderIds.includes(+teacherId)) {
              value = '已设置提醒'
              clickHandler = () => {
                this.$toast({
                  text: '您已设置过该位倾听师的上线提醒，请耐心等候'
                })
              }
            } else {
              value = '上线提醒'
              bgColor = COLOR.DARK_RED
              clickHandler = this.goToRemind
            }
          }
          result = {
            value,
            tip:
              jin === 0 && consultation_price === 0 && text_status === 1
                ? '首单免费'
                : '',
            bgColor,
            banned: jin === 1, // 是否禁止下单
            showIcon: text_status === 1,
            clickHandler
          }
        }
        // 语音倾诉
        else if (service.type === 'voice') {
          let value = '',
            tip = '',
            clickHandler = null,
            bgColor = COLOR.DARK_RED
          const jin = +this.teacherInfo.jin
          const ting_status = +this.teacherInfo.ting_status
          const firstOrder = +this.discountInfo.firstOrder
          const isShowZeroExperience = +this.teacherInfo.is_show_zeroexperience
          // ting_status: 0：已下线  1：空闲中   2:服务中
          if (ting_status === 0) {
            value = '已休息'
            bgColor = COLOR.GRAY
            // 倾听师上线提醒
            if (this.mixinIsApp && this.roleInfo.role !== 'qingting') {
              if (this.isLogin && this.remnderIds.includes(+teacherId)) {
                value = '已设置提醒'
                clickHandler = () => {
                  this.$toast({
                    text: '您已设置过该位倾听师的上线提醒，请耐心等候'
                  })
                }
              } else {
                value = '上线提醒'
                bgColor = COLOR.DARK_RED
                clickHandler = this.goToRemind
              }
            }
          } else if (ting_status === 1) {
            value = '立即倾诉'
            tip = firstOrder
              ? `首单${Number(this.teacherInfo.voice_price)}元`
              : ''
            clickHandler = () => {
              self.toOrder()
            }
            // 0元体验
            if (isShowZeroExperience) {
              tip = '0元体验'
            }
          } else {
            value = '服务中'
            clickHandler = null
            bgColor = COLOR.LIGHT_RED
          }
          const isShowCharity = this.teacherInfo.is_show_charity > 0
          const restcharityNum = this.teacherInfo.restcharity_num > 0
          if (isShowCharity && restcharityNum && !isShowZeroExperience) {
            if (+ting_status === 0 || +ting_status === 2) {
              let _toast =
                +ting_status === 2
                  ? '老师正在服务中，请稍后再试'
                  : '老师已经休息了，请晚点再试'
              clickHandler = () => {
                this.$toast({
                  text: _toast
                })
              }
            }
          }
          // 该倾听师是否暂停服务
          if (jin === 1) {
            value = '暂停服务'
            tip = ''
            clickHandler = null
            bgColor = COLOR.GRAY
          }
          result = {
            value,
            tip,
            bgColor,
            showIcon: ting_status === 1,
            clickHandler: () => {
              clickHandler && clickHandler()
            }
          }
        }
      }
      return result
    }
  },
  created() {
    this.fetchRemnders()
  },
  methods: {
    sendLetter() {
      this.$emit('letter')
    },
    toggleFollow() {
      this.$emit('follow')
    },
    fetchRemnders() {
      return getQingsuReminder({
        teacher_id: this.$route.params.userId
      })
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            this.remnderIds = data.teacher_ids || []
            this.remnderIds = this.remnderIds.map(Number) // id转数字
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onBtnClick() {
      this.btnMsg.clickHandler()
    },
    toOrder() {
      const userId = this.$route.params.userId
      if (this.qingsuType === 'voice') {
        this.$trackEvent('newprofilepages_listener_voice_click')
        EventBus.$emit('toQingsuOrder', {
          path: '/qingsu-order-page',
          query: {
            to_user_id: userId
          }
        })
      } else if (this.qingsuType === 'text') {
        this.$trackEvent('newprofilepages_listener_texttalk_click', {})
        EventBus.$emit('toQingsuOrder', {
          path: '/consult-text/order-page',
          query: {
            to_user_id: userId
          }
        })
      }
    },
    toTeacherPage() {
      this.$trackEvent('newprofilepages_qingsu', {})
      this.routerToStaic({
        path: '/qingsu-teacher-page',
        query: {
          id: this.$route.params.userId,
          cid: this.$route.query.cid || '',
          channel_flag: 'ptgrzy_yjqs'
        }
      })
    },
    async goToRemind() {
      // app里未登录
      if (!this.isLogin) {
        window.location.href = 'yixinli://open_user_login'
        return
      }
      try {
        const res = await setQingsuReminder({
          teacher_id: this.$route.params.userId
        })
        const { code, message } = res
        if (code !== 0) {
          return this.$toast({
            text: message
          })
        }
        this.eventStat(`设置上线提醒`)
        this.fetchRemnders()
        const hasPermission = await this.checkPermission()
        if (hasPermission) {
          return this.$toast({
            text: '设置成功！该倾听师上线时会第一时间提醒您'
          })
        }
        await this.showDialog()
        const myBridge = new Bridge()
        myBridge.call('checkNotificationSetting') // 跳到系统通知设置页面
      } catch (err) {
        console.log(err)
      }
    },
    checkPermission() {
      return new Promise(resolve => {
        const myBridge = new Bridge({
          methods: [
            {
              method: 'checkNotificationPermission',
              callback: ({ hasPermission }) => {
                resolve(hasPermission)
              }
            }
          ]
        })
        // 判断有没有开通 通知（push） 权限
        myBridge.call('checkNotificationPermission', {
          callbackName: 'checkNotificationPermission'
        })
      })
    },
    showDialog() {
      return new Promise(resolve => {
        this.$dialog({
          title: `设置成功！您还需在手机设置中打开通知功能才能收到上线提醒哦~`,
          theme: '#0B8BFF',
          buttons: [
            { label: '暂不设置' },
            {
              label: '前往设置',
              onClick: () => {
                resolve()
              }
            }
          ]
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-b {
  width: 100%;
  height: 148px;
  background: #ffffff;
  box-shadow: 0px -8px 20px -10px #ebefff;
  border-radius: 30px 30px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px 0 52px;
  box-sizing: border-box;
  .bar-item {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
      margin-bottom: 8px;
    }
  }
  .btn-large-wrap {
    width: 437px;
    height: 86px;
  }
  .tips {
    position: absolute;
    left: 5px;
    top: -25px;
    width: 118px;
    height: 56px;
    background: url('~images/platform/homepage/qingsu-first-order.png')
      no-repeat center/100%;
    box-sizing: border-box;
    padding-top: 9px;
    text-align: center;
    font-size: 22px;
    color: #fff;
    line-height: 22px;
  }
  .btn-large {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 48px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    // &.orange {
    //   background: linear-gradient(180deg, #feb6a9 0%, #fc7052 100%);
    // }
    // &.disabled {
    //   background: rgb(204, 204, 204);
    // }
    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
      margin-right: 12px;
    }
    .btn-large-content {
      text-align: center;
      .label {
        font-size: 32px;
        line-height: 36px;
      }
      .tips {
        font-size: 22px;
        font-weight: 400;
      }
    }
  }
}
</style>
